import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import Widget from "../../prefabricated/Widget";
import {Col, Row} from "reactstrap";
import BBIconEmptyBox from "../../../assets/bbCustomIcons/BBIconEmptyBox";
import {bbFormattedDateString} from "../../../util/bbHelpers";
import BBIconExclamationTriangleError from "../../../assets/bbCustomIcons/BBIconExclamationTriangleError";
import {Button, Card} from "@material-ui/core";
import {unregisterCloudIntegration} from "../../../actions";
import Dialog from "@material-ui/core/Dialog";
import {DialogActions, DialogTitle, IconButton} from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import CloudIntegrationDataAppsChart from "../charts/CloudIntegrationDataAppsChart";
import CloudIntegrationDataStorageChart from "../charts/CloudIntegrationDataStorageChart";
import CloudIntegrationDataDatabasesChart from "../charts/CloudIntegrationDataDatabasesChart";
import CloudIntegrationDataComputeChart from "../charts/CloudIntegrationDataComputeChart";
import {testintegrationObject} from "../../../app/routes/brbusiness/routes/CloudIntegration";
import {BRCustomizedTooltip} from "../accents/BRCustomizedTooltip";
import SVGCircleFilledIn from "../accents/SVGCircleFilledIn";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";


const ActiveIntegrationTiles = ({integrationId = null,})=>{
    const { entityInView, cloudIntegrations, loadingCloudIntegrations, loadingCloudIntegrationsError, loadingCloudIntegrationData, loadingCloudIntegrationDataError} = useSelector(({breachrisk}) => breachrisk);
    const dispatch = useDispatch();
    const cloudOptions = cloudIntegrations && cloudIntegrations[entityInView] && cloudIntegrations[entityInView].options;
    const cloudIntegrationObjects = cloudIntegrations && cloudIntegrations[entityInView] && cloudIntegrations[entityInView].integrations;
    // const cloudIntegrationObjects = testintegrationObject;
    const numofCloudIntegrations = cloudIntegrationObjects && Object.keys(cloudIntegrationObjects).length;
    const cloudIntegrationInView = cloudIntegrationObjects && cloudIntegrationObjects[integrationId]
    const hasError = cloudIntegrationObjects && cloudIntegrationInView && cloudIntegrationInView.has_error;

    const createdDate = cloudIntegrationInView && cloudIntegrationInView.created_datetime ? cloudIntegrationInView.created_datetime : "N/A";

    const integrationType = cloudIntegrationInView && cloudIntegrationInView.type && cloudIntegrationInView.type.name ? cloudIntegrationInView.type.name : "--";
    const description = cloudIntegrationInView && cloudIntegrationInView.description ? cloudIntegrationInView.description : `${integrationType} added ${bbFormattedDateString(createdDate, "monthYear")}`;

    const typeDescription = cloudIntegrationInView && cloudIntegrationInView.type.description && cloudIntegrationInView.type.description ? cloudIntegrationInView.type.description : "--";
    const logo = cloudIntegrationInView && cloudIntegrationInView.type && cloudIntegrationInView.type.logo_url ? cloudIntegrationInView.type.logo_url : "--";

    const [openDialog, setOpenDialog] = useState(false);
    const [openUnregisterForm, setOpenUnregisterForm] = useState(false);

    const onUnregister = (data) =>{
        console.log("unregister cloud integration pressed")
        dispatch(unregisterCloudIntegration(data, "user disconnected integration."))
        setOpenDialog(false)
    }

    console.log("Active Integration tile for integration", integrationId, "with descriptoin", description, "integration service", integrationType)

    return(
        <>
            <Card onClick={()=>setOpenDialog(true)}
                style={{ width: "95%",
                    boxShadow: "0 2px 5px 0 rgba( #000, 0.26)",
                         cursor: "pointer"}}
                  className={"d-inline-flex px-3 mx-2"}>
                <Row className={"p-0 m-0"} style={{width: "100%"}}>
                    {/*<Row>*/}
                    <Col sm={1} lg={1} md={1} className={"align-self-center"}>
                        {logo
                            ? <img className={"text-left"}
                                   style={{height: "2.5rem", width: "2.5rem", marginLeft: "-1.5rem"}}
                                   src={logo}
                                   alt={typeDescription}/>
                            : <BBIconEmptyBox/>
                        }
                    </Col>
                    {/*</Row>*/}
                    <Col className={"align-self-center"}>
                        <Row className={"mt-1 pt-1"}>
                            <Col className={"align-self-center"}>
                                <h4 style={{minHeight: "2.5em", maxHeight: "2.5em", width:"100%" ,whiteSpace: "normal" ,textOverflow: "ellipsis", overflow: "hidden"}}
                                    className={"align-self-center"}>{description ? description : "--"}
                                </h4>
                            </Col>
                            {hasError
                                ? <Col sm={1} lg={1} md={1} className={"p-0 m-0 align-self-center"}>
                                    <BRCustomizedTooltip title={cloudIntegrationInView && cloudIntegrationInView.error_message}>
                                        <span>
                                            {/*<BBIconExclamationTriangleError className={'text-bb-risk-high float-right'}/>*/}
                                            <SVGCircleFilledIn color={"#F28705"} glow pulse/>
                                        </span>
                                    </BRCustomizedTooltip>
                                </Col>
                                :  <Col sm={1} lg={1} md={1} className={"p-0 m-0 align-self-center"}>
                                    <BRCustomizedTooltip title={"Active Integration"}>
                                        <span>
                                            <SVGCircleFilledIn glow/>
                                        </span>
                                    </BRCustomizedTooltip>
                                </Col>
                             }
                        </Row>
                        <Row className={"text-center p-1"} style={{marginTop: "-1rem"}}>
                            {/*    <Col className={"m-0 p-0"}>*/}
                            {/*        <p className={"m-0 p-0  float-left"}><small><em>*/}
                            {/*            Last Verified: {cloudIntegrationInView*/}
                            {/*        && cloudIntegrationInView.last_verified*/}
                            {/*            ? bbFormattedDateString(cloudIntegrationInView.last_verified, "microYear")*/}
                            {/*            : "--"}*/}
                            {/*        </em></small></p>*/}
                            {/*    </Col>*/}
                            <Col className={"m-0 p-0"}>
                                <p className={"m-0 p-0"}><small><em>
                                    Created: {createdDate
                                    ? bbFormattedDateString(createdDate, "shortFullMonth")
                                    : "--"}
                                </em></small></p>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card>
            {openDialog &&
            <Dialog open={openDialog}
                    maxWidth={"lg"}
                    fullWidth={true}
                    onClose={()=>setOpenDialog(false)}
                    aria-labelledby={"form-dialog-title"}>
                <DialogTitle className="form-dialog-title mr-4 ml-4"
                             id="customized-dialog-title"
                             onClose={()=>setOpenDialog(false)}>
                    <div className={"row"}>

                        <div className={"col-6 p-0 m-0"}>

                        </div>
                        <div className={"col-11"}/>

                        <div className={"col-1 text-right"}>

                            <IconButton
                                onClick={()=>setOpenDialog(false)}>
                                <CloseIcon/>
                            </IconButton>
                        </div>
                    </div>
                        <Row className={"text-center"}>
                            <Col>
                                <h1>About {description}</h1>
                            </Col>
                        </Row>

                        <Row className={"p-1"}>
                            <Col className={"m-0 p-0"}>
                                <p className={"m-0 p-0  float-left"}><small><em>
                                    Last Verified: {cloudIntegrationInView
                                && cloudIntegrationInView.last_verified
                                    ? bbFormattedDateString(cloudIntegrationInView.last_verified, "microYear")
                                    : "--"}
                                </em></small></p>
                            </Col>
                            <Col className={"m-0 p-0"}>
                                <p className={"m-0 p-0 float-right"}><small><em>
                                    Created: {createdDate
                                    ? bbFormattedDateString(createdDate, "shortFullMonth")
                                    : "--"}
                                </em></small></p>
                            </Col>
                        </Row>
                    {hasError
                        ?<Row >
                            <Col className={"text-center  "}>
                            <span style={{backgroundColor: "#F2870530",
                                borderRadius: "12px",}}
                                  className={"text-center m-3 px-3 pb-3 pt-3"}>

                                <h3 style={{color: "#F28705"}} className={"align-self-center d-inline "}>
                                <BBIconExclamationTriangleError style={{fontSize: "2em"}}
                                                                className={'text-bb-risk-high align-self-center d-inline'}/>&nbsp;
                                    {cloudIntegrationInView && cloudIntegrationInView.error_message}
                            </h3>
                            </span>
                            </Col>
                        </Row>
                        : null}
                </DialogTitle>

                <DialogContent className={"bg-lightest-gray"}>
                    <Row>
                        <Col>
                            <CloudIntegrationDataAppsChart integrationId={integrationId}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <CloudIntegrationDataStorageChart integrationId={integrationId}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <CloudIntegrationDataDatabasesChart integrationId={integrationId}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <CloudIntegrationDataComputeChart integrationId={integrationId}/>
                        </Col>
                    </Row>
                </DialogContent>
                <DialogActions>
                    {/*<Row>*/}
                    {/*    <Col>*/}
                            <Button onClick={()=>onUnregister(integrationId)}
                                    aria-labelledby={"disable"}
                                    variant={"contained"}
                                    color={"secondary"}>
                                Disable Integration
                            </Button>
                        {/*</Col>*/}
                        {/*<Col>*/}
                            <Button onClick={()=>setOpenDialog(false)} aria-labelledby={"close"} variant={"contained"} color={"primary"}>
                                Close
                            </Button>
                    {/*    </Col>*/}
                    {/*</Row>*/}
                </DialogActions>

            </Dialog> }
        </>
    )
}

const ActiveIntegrationTileSection = ({arrayOfIntegrationObjects = null}) =>{

    const numOfIntegrations = Array.isArray(arrayOfIntegrationObjects) && arrayOfIntegrationObjects.length;

console.log("ActiveIntegrationTileSection", numOfIntegrations, "and then integrations", arrayOfIntegrationObjects)

    if(numOfIntegrations > 0 && numOfIntegrations <= 4){
        console.log("More than zero integrations, less than or equal to 4", arrayOfIntegrationObjects)
        return(
            <Row style={{width: "100%"}}>
                {arrayOfIntegrationObjects.map((object, index)=>(
                    <Col sm={numOfIntegrations >= 4
                        ? 3
                        : numOfIntegrations === 3
                            ? 4
                            : 6}
                         lg={numOfIntegrations >= 4
                             ? 3
                             : numOfIntegrations === 3
                                 ? 4
                                 : 6}
                         key={`${object.id}_${index}`}
                         className={"text-center m-0 p-0"}>
                        <ActiveIntegrationTiles integrationId={object.id}/>
                    </Col>
                ))

                }
            </Row>
        )
    } else if(numOfIntegrations > 0 && numOfIntegrations > 4){
        console.log("More than zero integrations, more than four", arrayOfIntegrationObjects)
        const arrayofArraysForIntegrations = [];
        const integrationsMod4 = numOfIntegrations % 4;
        const numOfRowsToMake = (numOfIntegrations - integrationsMod4) / 4;

        // const spliceIntoSeperateArrays = (integrationArray, numOfRowsToMake, in)


        while(arrayofArraysForIntegrations.length < numOfRowsToMake){
            arrayofArraysForIntegrations.push(arrayOfIntegrationObjects.splice(0, 4));
        }

        arrayofArraysForIntegrations.push(arrayOfIntegrationObjects.splice(-integrationsMod4));

        console.log("This is the new array to make nice neat rows adn stuff", arrayofArraysForIntegrations);

        return arrayofArraysForIntegrations.map((array)=>(
                    <Row style={{width: "100%"}} className={"py-2"}>
                        {array.map((object, index)=>(
                            <Col sm={3}
                                 lg={3}
                                 key={`${object.id}_${index}`}
                                 className={"text-center m-0 p-0"}>
                                <ActiveIntegrationTiles integrationId={object.id}/>
                            </Col>
                        ))
                        }
                    </Row>)
                )
    }else{
        console.log("no integrations found")
       return(<Row>
               <Col>
                   <h4 className={"text-center"}><em>No cloud integrations are active at this time... please select an integration type above to register.</em></h4>
               </Col>
           </Row>
       )
    }


}

export default ActiveIntegrationTileSection;